export default __webpack_public_path__ + "b539e581d41446e11c58812ccc282bee.svg";